var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftPanelOpen = function SvgLeftPanelOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.167 5.333v5.334L12.833 8zM2 16c-.53 0-.957-.176-1.281-.499C.396 15.177.22 14.75.22 14.22V1.78c0-.53.176-.957.499-1.281C1.043.176 1.47 0 2 0h12c.53 0 .957.176 1.281.499.323.324.499.751.499 1.281v12.44c0 .53-.176.957-.499 1.281-.324.323-.751.499-1.281.499zm3.333-1.333V1.333H2a.45.45 0 0 0-.333.134.45.45 0 0 0-.134.333v12.4q0 .2.134.333.133.134.333.134zm1.334 0H14a.45.45 0 0 0 .333-.134.45.45 0 0 0 .134-.333V1.8a.45.45 0 0 0-.134-.333.45.45 0 0 0-.333-.134H6.667z"
  })));
};
export default SvgLeftPanelOpen;